import { Card } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { Check } from "lucide-react";
import { cn } from "../../../lib/utils";
import { useNavigate } from "react-router-dom"; // 1. Import useNavigate
import { pricingPlans } from "../../../data/lifeChangingPlans"; // 2. Import plans data
import { trackReportEvent } from "../../../utils/analytics";

export const PricingSection = () => {
  const navigate = useNavigate(); // 3. Initialize the navigate function

  // 4. Handle button click to navigate
  const handleBuyNow = (plan) => {
    trackReportEvent("select", {
      reportName: plan.title,
      reportId: plan.id,
      price: plan.price,
    });

    navigate(`/life-changing-report/${plan.id}`);
  };

  return (
    <section className="bg-gradient-to-b from-cosmic-red/10 to-background-red">
      <div id="pricing-section" className="container mx-auto px-6 pt-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground">
            Choose Your Plan
          </h2>
          <p className="text-lg text-muted-foreground mt-4">
            Select the report that best fits your needs.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-3 gap-8 items-start">
          {pricingPlans.map((plan) => ( // Use data from plans.ts
            <Card
              key={plan.id}
              className={cn(
                "p-8 border-cosmic-gold/20 bg-card-red/50 backdrop-blur-sm flex flex-col h-full",
                plan.isBestSeller && "border-cosmic-gold ring-2 ring-cosmic-gold shadow-[0_0_30px_hsl(var(--mystic-gold)/0.4)]"
              )}
            >
              <div className="flex-grow">
                <Badge 
                  variant={plan.isBestSeller ? "default" : "secondary"}
                  className={cn(plan.isBestSeller && "bg-gradient-to-b from-cosmic-gold to-cosmic-gold-dark text-primary-foreground")}
                >
                  {plan.badge}
                </Badge>
                
                <h3 className="text-2xl font-bold text-foreground mt-6">{plan.title}</h3>
                <p className="text-muted-foreground mt-2 h-12">{plan.subtitle}</p>

                <div className="my-8">
                  <span className="text-2xl text-muted-foreground line-through">{plan.priceOriginal}</span>
                  <span className="text-5xl font-extrabold text-cosmic-gold ml-2">{plan.priceFinal}</span>
                </div>
                
                <ul className="space-y-4 text-left">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <Check className="w-5 h-5 text-cosmic-gold flex-shrink-0 mt-1" />
                      <span className="text-muted-foreground">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <p className="text-muted-foreground text-sm mt-8">{plan.description}</p>
              </div>

              <div className="mt-8">
                <Button 
                  onClick={() => handleBuyNow(plan)} // 5. Add onClick handler
                  variant={plan.isBestSeller ? "cosmic" : "cosmic-outline"} 
                  size="lg" 
                  className="w-full"
                >
                  BUY NOW
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
